import { UserStatus } from 'api/models';
import { getUserLabel } from 'utils/get-user-label';

export const getDataFormattedForSelect = (user) => {
  if (user) {
    return {
      value: user.emailId,
      imageUrl: user?.photoUrl,
      description: user?.role?.roleName,
      label: getUserLabel(user),
      ...user,
    };
  }

  return user;
};

export const getFormattedUsersList = (users) => {
  if (users) {
    return users.map((user) => getDataFormattedForSelect(user));
  }

  return users;
};

export const getOptions = (allMembers, projectMembers, userType) => {
  return getFormattedUsersList(
    allMembers.filter(
      (member) =>
        member.userStatus !== UserStatus.Inactive &&
        member.userType === userType &&
        !projectMembers.includes(member.userId),
    ),
  );
};
